import React from 'react';
import { Hero } from '../components/home/Hero';
import { Confianza } from '../components/home/Confianza';
import { Testimonios } from '../components/home/Testimonios';
import { QuienesSomos } from '../components/home/QuienesSomos';
import { Servicios } from '../components/home/Servicios';
import { QuickActions } from '../components/home/QuickActions';
import { FinanciacionSection } from '../components/home/FinanciacionSection';
import { VenderSection } from '../components/home/VenderSection';
import { PermutasSection } from '../components/home/PermutasSection';
import { PorQueVcars } from '../components/home/PorQueVcars';
import { Proceso } from '../components/home/Proceso';
import { CtaFinal } from '../components/home/CtaFinal';
import { Section, SectionHeading } from '../components/ui/Section';
import { Reveal } from '../components/ui/Reveal';
import { ConsultaForm } from '../components/forms/ConsultaForm';
import { useSeo } from '../utils/seo';
export function Home() {
  useSeo();
  return <main data-id="element-486" data-mp="30xb7fy9sinu3">
      <Hero data-id="element-487" data-mp="30x1ime0hempz" />
      <Confianza data-id="element-488" data-mp="30vgnam6cezr2" />
      <Testimonios data-id="element-489" data-mp="30w04u1s2zm4k" />
      <QuienesSomos data-id="element-490" data-mp="30uf948u15x54" />
      <Servicios data-id="element-491" data-mp="2vxycsrcogcgy" />
      <QuickActions data-id="element-492" data-mp="2vxf4m2ctx2g4" />
      <FinanciacionSection data-id="element-493" data-mp="2vy82edtt8hm4" />
      <VenderSection data-id="element-494" data-mp="2vvvn68ffslcr" />
      <PermutasSection data-id="element-495" data-mp="2qybz6gsxsu7m" />
      <PorQueVcars data-id="element-496" data-mp="2qxkdbxp56auj" />
      <Proceso data-id="element-497" data-mp="2qx0tgbfxlcdv" />
      <Section id="contacto" data-id="element-498" data-mp="2r0opbh8umavr">
        <Reveal data-id="element-499" data-mp="2mxa7qm59hmg7">
          <SectionHeading title="Dejá tu consulta" lead="Atención personalizada para encontrar el vehículo ideal. Un asesor te responde en el día." align="center" data-id="element-500" data-mp="2mxs0v9wmnkjw" />
        </Reveal>
        <Reveal delay={0.05} data-id="element-501" data-mp="2d6fbqq27r8hk">
          <div className="mx-auto max-w-3xl" data-id="element-502" data-mp="2d5dwsai2u1uk">
            <ConsultaForm data-id="element-503" data-mp="287cc5l505ugz" />
          </div>
        </Reveal>
      </Section>
      <CtaFinal data-id="element-504" data-mp="239ay5emfolcd" />
    </main>;
}